import { GenericAbortSignal } from "axios";
import {
  FieldExecutiveSearch,
  IDropdownListSearch,
  IRoleDropdownListSearch,
  ISelectSearch,
  IWarehouseDropdownListSearch,
  MarketHiringSearch,
} from "../../../types/dropdownInterface";
import api from "../../../lib/api";
import { IDropdownBaseQuery } from "../../../types/commonInterface";

export const getUserDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/user-list/${data.page}/10?search=${data?.search ?? ""}&id=${data?.id??""}`, {
    signal: data.signal,
  });
};

export const getLeadDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/lead-list-id/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getBranchDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/branch-list/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getDivisionDropdownListApi = (data: IDropdownListSearch) => {
  return api.get(`/dropdowns/divisions/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getHubDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/hub-list/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getFranchiseDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/pincode/franchise/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getDepartmentDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/department-list/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getBankDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/bank-list/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getVehicleDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/vehicle-type-list/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getRoleDropdownListApi = async (data: IRoleDropdownListSearch) => {
  return await api.get(
    `/dropdowns/role-list/${data.page}/10?search=${data?.search.searchValue ?? ""}&department=${
      data?.search?.departmentId
    }`,
    {
      signal: data.signal,
    }
  );
};

export const getStateDropdownListApi = async (data: { stateName?: string; signal?: any }) => {
  return await api.get(`/dropdowns/state?search=${data?.stateName ?? ""}`, {
    signal: data?.signal,
  });
};

export const getDistrictDropdownListApi = async (data: IDropdownListSearch) => {
  const searchValue =
    typeof data?.search === "string"
      ? data.search
      : data?.search?.searchValue ?? "";

  return api.get(`/dropdowns/pincode/district/${data.page ?? 0}/10?search=${searchValue}`, {
    signal: data?.signal,
  });
};

export const getCustomerDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/customer/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getReportTypeDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/reportType/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getVendorDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/master-vendor/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getVendorPincodeDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/pincode/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getPermissionDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/permission/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getCompanyDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/our-company-list/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getPackageTypeNameAsValueDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/package-type-name-as-value/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getWarehouseDropdownListByCustomerIdApi = async (data: IWarehouseDropdownListSearch) => {
  // return data interface not defined because data is cosumed differently.
  return await api.get(`/dropdowns/warehouse/${data.page ?? 0}/10`, {
    params: {
      search: data?.search ?? "",
      customer_id: data?.customer_id ?? -1,
    },
    signal: data.signal,
  });
};

export const getLocationDropdownListByPincode = (pincode: string) => {
  return api.get(`/dropdowns/office-location`, {
    params: { pincode },
  });
};

export const getSectionDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/section/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getPayrollGroupDropdownListApi = async (data: { signal: GenericAbortSignal }) => {
  return await api.get(`/dropdowns/payroll-group`, {
    signal: data.signal,
  });
};

export const getHrRuleDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/rules/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getFacilityProviderDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/facility-provider/${data.page}/10`, {
    signal: data.signal,
    params: {
      search: data.search ?? "",
      type: data.type ?? "",
    },
  });
};

export const getFieldExecutiveDropdownListApi = async (data: FieldExecutiveSearch) => {
  return await api.get(`/dropdowns/field-executive/${data.page}/10`, {
    signal: data.signal,
    params: {
      type: data.type ?? "",
      search: data.search ?? "",
      facility_provider_id: data.facilityProviderId ?? undefined,
      department: data.department ?? "",
    },
  });
};

export const getVechicleDropdownListApi = async (data: FieldExecutiveSearch) => {
  return await api.get(`/dropdowns/dashboard-vehicle/${data.page}/10`, {
    signal: data.signal,
    params: {
      type: data.type ?? "",
      search: data.search ?? "",
      facility_provider_id: data.facilityProviderId ?? 0,
    },
  });
};

export const getPrsDriverDropdownListApi = async (data: FieldExecutiveSearch) => {
  return await api.get(`/dropdowns/dashboard-driver/${data.page}/10`, {
    signal: data.signal,
    params: {
      type: data.type ?? "",
      search: data.search ?? "",
      facility_provider_id: data.facilityProviderId ?? 0,
    },
  });
};

export const getMarketHiringDropdownListApi = async (data: MarketHiringSearch) => {
  return await api.get(`/dropdowns/dashboard-market-hiring/${data.page}/10`, {
    signal: data.signal,
    params: {
      facility_provider_id: data.facilityProviderId ?? 0,
      search: data.search ?? "",
    },
  });
};

export const getPrqListDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/dashboard-pickup-request/${data.page}/10`, {
    signal: data.signal,
    params: {
      search: data?.search ?? "",
    },
  });
};

export const getPrsControllerDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/user-controller/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
    params: {
      department: data.department,
    },
  });
};

export const getPincodeDistrictDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/pincode/district/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getAssignedCustomersApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/assigned-entities/${data.page}/20`, {
    signal: data.signal,
    params: {
      search: data?.search ?? "",
      type: "CUSTOMER",
    },
  });
};

export const getAssignedLeadsApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/assigned-entities/${data.page}/20`, {
    signal: data.signal,
    params: {
      search: data?.search ?? "",
      type: "LEAD",
    },
  });
};

export const getAssignedEntitiesDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/assigned-entities/${data.page}/10`, {
    signal: data.signal,
    params: {
      search: data.search ?? "",
      type: data.type ?? "",
    },
  });
};

export const getMyActivityDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/assigned-activity-list/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getSalesActivityDropdownListApi = async (data: IDropdownListSearch) => {
  return await api.get(`/dropdowns/activity-list/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getPayrollDropdownListApi = async (data: {
  page: number;
  search?: string;
  signal?: any;
  payrollGroupId: number;
}) => {
  return await api.get(`/dropdowns/payroll/${data.page}/12`, {
    signal: data.signal,
    params: {
      payroll_group_id: data.payrollGroupId || undefined,
      search: data.search || undefined,
    },
  });
};

export const getUserCodeDropdownListApi = (data: IDropdownListSearch) => {
  return api.get(`/dropdowns/user-code-dropdown/${data.page}/10?search=${data?.search ?? ""}`, {
    signal: data.signal,
  });
};

export const getAwbPackageContentDropdownListApi = (data: ISelectSearch) => {
  return api.get(`/dropdowns/content-list/${data.page}/10`, {
    params: {
      search: data.search?.length ? data.search : undefined,
    },
    signal: data.signal,
  });
};

export type IOfficeLocationParams = {
  type?: string;
};

export type IGetOfficeLocationDropdown = IDropdownBaseQuery & IOfficeLocationParams;

export const getOfficeLocationApi = (data: IGetOfficeLocationDropdown) => {
  return api.get(`dropdowns/office-location/${data.page ?? 0}/${data.pageSize ?? 30}`, {
    params: {
      search: data.search || "",
      type: data.type || "",
    },
  });
};
export const getOfficeLocationApiB = (data: IGetOfficeLocationDropdown) => {
  return api.get(`dropdowns/office-location/${data.page ?? 0}/${data.pageSize ?? 30}`, {
    params: {
      search: data.search || "",
      type: "BRANCH",
    },
  });
};

export const getZoneDropdownListApi = async (data: IDropdownListSearch) => {
  const searchValue = typeof data?.search === "string" ? data.search : data?.search?.searchValue ?? "";
  return api.get(`/dropdowns/zone/${data.page}/10?search=${searchValue}`, {
    signal: data.signal,
  });
};

export const getAreaCodeDropdownListApi = async (data: IDropdownListSearch) => {
  const searchValue =
    typeof data?.search === "string"
      ? data.search
      : data?.search?.searchValue ?? "";

  return api.get(`/dropdowns/area-codes/${data.page}/10?search=${searchValue}`, {
    signal: data.signal,
  });
};